///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import Stats from "three/examples/jsm/libs/stats.module.js";
import { IComponent, components, Viewer } from "@inweb/viewer-three";

class StatsPanelComponent implements IComponent {
  protected viewer: Viewer;
  protected stats: Stats;

  constructor(viewer: Viewer) {
    this.stats = new Stats();
    this.stats.dom.style.position = "absolute";
    this.stats.dom.style.left = "0px";
    this.stats.dom.style.top = "0px";
    viewer.canvas.parentElement.appendChild(this.stats.dom);

    this.viewer = viewer;
    this.viewer.addEventListener("render", this.updateStats);
    this.viewer.addEventListener("animate", this.updateViewer);
  }

  dispose() {
    this.viewer.removeEventListener("render", this.updateStats);
    this.viewer.removeEventListener("animate", this.updateViewer);

    this.stats.dom.remove();
    this.stats = undefined;
  }

  updateStats = () => {
    this.stats.update();
  };

  updateViewer = () => {
    this.viewer.update();
  };
}

components.registerComponent("StatsPanelComponent", (viewer) => new StatsPanelComponent(viewer));
